<script lang="ts">
  // import { intcomma } from 'journalize';
  import { formatPercent } from '../utils/format.js';
  import Photos from './Photos.svelte';
  import {slugify} from '../utils/slugify'

  // types
  import type { CrosswalkImage } from '../types';

  /** Name parts, kept separate so the last name can be shown alone where space is tight ('' when missing) */
  export let candidateFirstName: string;
  export let candidateMiddleName: string;
  export let candidateLastName: string;
  /** Measures only: 'Yes' / 'No' (they have no name parts) */
  export let choiceTitle: string | undefined;
  /** The feed's choiceId: AP candidate id, or 'yes' / 'no' for measures */
  export let choiceId: string;
  export let candidateVotes: number;
  export let totalVotes: number;
  export let isIncumbent: boolean;
  export let isWinner: boolean;
  /** CSS party name the styles use: 'dem' | 'gop' | 'np'... or 'yes' / 'no' (partyClass) */
  export let candidateParty: string;
  export let raceID: string;
  export let isRunoff: boolean;
  export let hasDroppedOut = false;
  export let wideBar: boolean;

  export let lookup: CrosswalkImage | undefined;

  // Race IDs where a runoff candidate gets a checkmark instead of the Runoff label.
  // Empty for now; the primary used this for its races.
  const runoffOverrideIds: string[] = [];

  $: barPercent = formatPercent(candidateVotes, totalVotes);
  // one string, only for the alt text and slug class
  $: name =
    choiceTitle ??
    [candidateFirstName, candidateMiddleName, candidateLastName]
      .filter(Boolean)
      .join(' ');
</script>

{#if wideBar == false}
<td class="candidate__cell">
  <div class="candidate-headshot {slugify(name)}" class:dropped={hasDroppedOut}>
  {#if lookup}
    <Photos
      name = {name}
      src = {lookup.png}
      avif = {lookup.avif}
      webp = {lookup.webp}
      party = {candidateParty}
    />
  {/if}
  </div>
</td>
{/if}

<th scope="row" class="candidate__cell candidate__cell-name">
  <span class="candidate__cell-checkmark candidate__{candidateParty}"> {isWinner || (isRunoff && (runoffOverrideIds.includes(raceID))) ? `✓` : ''}</span>
  <div class="{isWinner || (isRunoff && (runoffOverrideIds.includes(raceID))) ? 'text-medium' : ''}">
    {#if hasDroppedOut}
      <span class="candidate__cell-dropped candidate">
        Dropped out
      </span><br>
    {/if}
    <!-- First and middle names are desktop only, so mobile shows the last name -->
    {#if candidateFirstName}<span class="desktop-only"
      >{candidateFirstName} {#if candidateMiddleName}{candidateMiddleName}{/if}</span
    >{/if}
    <span class="breakpoint"
      >{choiceTitle ?? candidateLastName}
      {#if isRunoff && (!runoffOverrideIds.includes(raceID))}
      <span
        class="candidate__cell-runoff candidate__">
        Runoff
        </span>
      {/if}
      {#if isIncumbent}
        <span
          class="candidate__cell-incumbent"
          title="Currently holds this office"
          role="img"
          aria-label="incumbent">*</span
        >
      {/if}
    </span>

  </div>
</th>
<td class="candidate__cell bar-chart {raceID} {wideBar ?  'wide-bar' : ''}" aria-hidden="true">
  <div class="bar-container {raceID}">
    <div
      class="inner-bar
      {(candidateParty !== 'np')? candidateParty :
      (choiceId !== 'yes') && (choiceId !== 'no') ?  candidateParty : choiceId} {raceID}"
      style="width:{barPercent}%"
    />
  </div>
</td>
<td
  class="candidate__cell candidate__cell-pct {isWinner || (isRunoff && (runoffOverrideIds.includes(raceID))) ? 'text-medium' : ''} text-right"
  aria-label="{formatPercent(candidateVotes, totalVotes)}%"
>
  {formatPercent(candidateVotes, totalVotes)}<span class="candidate__pct-symbol">%</span>
</td>
